module.exports = __webpack_public_path__ + "assets/966916e41d97a6444fc0dba6984ee4da.mp3";